import { useEffect } from "react";

const SITE_NAME = "ProfitMigo";
// Always use the canonical production URL — never window.location.origin,
// which resolves to http://localhost:3000 in raw HTML / crawled contexts.
const SITE_URL = "https://profitmigo.com";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Applies title / meta / canonical / OG / twitter / robots to the document head.
export function useSeo({ title, description, path = "", robots = "index, follow", ogImage }) {
  useEffect(() => {
    const canonical = `${SITE_URL}${path || window.location.pathname}`;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots);
    upsertLink("canonical", canonical);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:url", canonical);
    if (ogImage) upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
  }, [title, description, path, robots, ogImage]);
}

// Injects a JSON-LD structured-data block, cleaned up on unmount.
export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, data]);
}

export { SITE_URL, SITE_NAME };
